'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SORT_SELECT = exports.CLASS_VISIBLE = exports.CLASS_PRODUCT_THUMB = exports.CLASS_EXPANDED = exports.CLASS_FILTERS_OPEN = exports.VENDOR_REVIEVE_BUTTON = exports.REVIEVE_BUTTON = exports.ATTR_CONTENT_BLOCK_POSITION = exports.CONCERN_FACET_SELECTOR = exports.PRODUCTS_SELECTOR = exports.NO_RESULTS_SELECTOR = exports.TOGGLE_FILTERS = exports.SORT_SELECT_SELECTOR = exports.LOAD_MORE_BUTTON_SELECTOR = exports.COLLECTION_PRODUCT_PER_PAGE = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('lity/dist/lity');

var _ProductThumbnail = require('./../../objects/product/ProductThumbnail');

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _ProductThumbnailPrint = require('./../../objects/product/ProductThumbnailPrint');

var _CustomTagSelectFacet = require('./CustomTagSelectFacet');

var _ajaxCollectionV = require('@process-creative/ajax-collection-v3');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-collection-template]';
//Ajax Collection Imports
/*
 *  Collection Template
 *    Contains all the scripts used for the collection template.
 *
 *  Version:
 *    1.0.0 - 2020/07/10
 */

var COLLECTION_PRODUCT_PER_PAGE = exports.COLLECTION_PRODUCT_PER_PAGE = '[data-collection-product-count]';
var LOAD_MORE_BUTTON_SELECTOR = exports.LOAD_MORE_BUTTON_SELECTOR = '[data-collection-load-more]';
var SORT_SELECT_SELECTOR = exports.SORT_SELECT_SELECTOR = '[data-collection-sort]';
var TOGGLE_FILTERS = exports.TOGGLE_FILTERS = '[data-collection-toggle-filters]';
var NO_RESULTS_SELECTOR = exports.NO_RESULTS_SELECTOR = '[data-collection-no-results]';
var PRODUCTS_SELECTOR = exports.PRODUCTS_SELECTOR = '[data-collection-template-products]';
var CONCERN_FACET_SELECTOR = exports.CONCERN_FACET_SELECTOR = '[data-concern-facet]';
var ATTR_CONTENT_BLOCK_POSITION = exports.ATTR_CONTENT_BLOCK_POSITION = 'data-content-block-position';
var REVIEVE_BUTTON = exports.REVIEVE_BUTTON = '[data-revieve-button]';
var VENDOR_REVIEVE_BUTTON = exports.VENDOR_REVIEVE_BUTTON = '#revieve-button';

//Classes
var CLASS_FILTERS_OPEN = exports.CLASS_FILTERS_OPEN = 'is-filters-open';
var CLASS_EXPANDED = exports.CLASS_EXPANDED = 'is-expanded';
var CLASS_PRODUCT_THUMB = exports.CLASS_PRODUCT_THUMB = 'c-collection__product o-products-list__product o-product-thumbnail';
var CLASS_VISIBLE = exports.CLASS_VISIBLE = 'is-visible';
var SORT_SELECT = exports.SORT_SELECT = 'c-collection__filters-sort';

var CollectionTemplate = function (_AjaxCollectionTempla) {
  (0, _inherits3.default)(CollectionTemplate, _AjaxCollectionTempla);

  function CollectionTemplate(container) {
    (0, _classCallCheck3.default)(this, CollectionTemplate);

    //Setup Pagination
    var _this = (0, _possibleConstructorReturn3.default)(this, (CollectionTemplate.__proto__ || Object.getPrototypeOf(CollectionTemplate)).call(this, container));

    _this.setSortSelectWidth = function () {
      var extraWidth = 30;

      var selectedOptionText = (0, _jquery2.default)(_this.sortSelect).find('option:selected').text();

      if (selectedOptionText) {
        (0, _jquery2.default)(_this.hiddenSortSelectTextElem).text(selectedOptionText);
        /* const mockElement = $(`<span style='display: inline-block; height: 0; overflow: hidden'>${selectedOptionText}</span>`)
        mockElement.appendTo(this.container) */
        var width = (0, _jquery2.default)(_this.hiddenSortSelectTextElem).width();
        (0, _jquery2.default)(_this.sortSelect).width(width + extraWidth);
      }
    };

    _this.productPerPage = container.find(COLLECTION_PRODUCT_PER_PAGE);
    _this.pagination.setPaginator(new _ajaxCollectionV.LoadMore(_this, container.find(LOAD_MORE_BUTTON_SELECTOR)));

    //Ajax Collection Setup
    _this.draw.setDisplayMode('FirstAvailableVariant');

    _this.sortSelect = container.find(SORT_SELECT_SELECTOR);
    _this.sort.addSorter(new _ajaxCollectionV.SelectSorter(_this, _this.sortSelect));
    _this.sortSelect.on('change', _this.setSortSelectWidth);
    setTimeout(_this.setSortSelectWidth, 10);

    //Setup Filters

    _this.concernFilter = new _ajaxCollectionV.TagFilter(_this, 'concern', _ajaxCollectionV.OPERATION_OR);
    _this.filters.addFilter(_this.concernFilter);

    if (container.find(CONCERN_FACET_SELECTOR).length) {
      var concernSelectFacet = new _CustomTagSelectFacet.CustomTagSelectFacet({
        template: _this, filter: _this.concernFilter, hasAll: false, multiple: false,
        showTitle: false, title: 'no title',
        container: CONCERN_FACET_SELECTOR, prefixes: ['Skin Concern'],
        allName: (0, _pcSlateTools.t)('collections.concern_everything')
      });

      _this.filters.addFacet(concernSelectFacet);
    }

    //Elements
    _this.noResults = container.find(NO_RESULTS_SELECTOR);
    _this.products = container.find(PRODUCTS_SELECTOR);

    //Events
    container.on('click touchend', TOGGLE_FILTERS, function (e) {
      return _this.onFiltersToggle(e);
    });

    // Used to determine width of text box
    _this.hiddenSortSelectTextElem = (0, _jquery2.default)( /*html*/'\n      <span\n        style=\'display: inline-block; height: 0; overflow: hidden; visibility: hidden;\'\n        class=\'' + SORT_SELECT + '\'\n      ></span>\n    ');
    _this.hiddenSortSelectTextElem.appendTo(_this.container);

    var seconds = 0;
    _this.checkModal = setInterval(function () {
      var vendorRevieve = (0, _jquery2.default)(VENDOR_REVIEVE_BUTTON);
      if (vendorRevieve.length > 0) clearInterval(_this.checkModal);
      seconds += 1;
      if (seconds > 60) clearInterval(_this.checkModal);

      // Hide reveive vendor button
      vendorRevieve.hide();

      // Check if gtm link, then trigger revieve app
      var params = (0, _pcSlateTools.getQueryParams)();
      var isGtmLink = params.ref && params.ref === 'skincare-quiz' ? true : false;
      if (isGtmLink) vendorRevieve[0] && vendorRevieve[0].click();

      // Click event listener for custom revieve button
      (0, _jquery2.default)(document).on('click touchend', REVIEVE_BUTTON, function () {
        return vendorRevieve[0] && vendorRevieve[0].click();
      });
    }, 200);
    return _this;
  }

  (0, _createClass3.default)(CollectionTemplate, [{
    key: 'generatePrint',
    value: function generatePrint(v) {
      var p = v.product;

      var url = this.getVariantUrl(v);

      var p2 = Object.assign({}, p); //Duplicate
      p2.variants = p2.variants.map(function (variant) {
        var v2 = Object.assign({}, variant); //Duplicate
        delete v2.product; //Remove circular reference
        return v2;
      });

      return (0, _ProductThumbnailPrint.ProductThumbnailPrint)(p, p2, v, CLASS_PRODUCT_THUMB, url);
    }
  }, {
    key: 'getContentBlockPosition',
    value: function getContentBlockPosition(cb, thumbnails) {
      var pos = parseInt(cb.attr(ATTR_CONTENT_BLOCK_POSITION));
      if (isNaN(pos) || !isFinite(pos)) return 9999;
      if (pos > thumbnails.length + 1) {
        cb.removeClass(CLASS_VISIBLE);
      } else {
        cb.addClass(CLASS_VISIBLE);
      }
      return pos;
    }
  }, {
    key: 'onVariantsDrawn',
    value: function onVariantsDrawn(variants) {
      this.updateLoadMoreCount(variants);

      if (variants.length) {
        this.noResults.removeClass(CLASS_VISIBLE);
        (0, _ProductThumbnail.InitializeInactiveThumbnails)();
        return;
      }

      //Show empty message
      this.noResults.addClass(CLASS_VISIBLE);
    }
  }, {
    key: 'updateLoadMoreCount',
    value: function updateLoadMoreCount(variants) {
      var unpaginatedProductCount = this.draw.unpaginatedProductCount;
      var currentNumber = variants.length;
      if (unpaginatedProductCount != '' || unpaginatedProductCount != undefined) {
        // display number of product perpage
        var message = (0, _pcSlateTools.t)('collections.product_count', { count: currentNumber, total: unpaginatedProductCount });
        this.productPerPage.html(message);
      }
    }
  }, {
    key: 'onFiltersToggle',
    value: function onFiltersToggle(e) {
      e.preventDefault();
      e.stopPropagation();

      this.facetToggle.forEach(function (e) {
        return e.toggleClass(CLASS_FILTERS_OPEN);
      });
    }
  }]);
  return CollectionTemplate;
}(_ajaxCollectionV.AjaxCollectionTemplate);

/*** Initialize Collection Template ***/


(0, _jquery2.default)(document).ready(function () {
  //Find container
  var container = (0, _jquery2.default)(CONTAINER_SELECTOR);
  if (!container.length) return;
  if (container.attr('data-initialized')) return;

  //Create the template, we use window.collection for TESTING only!!
  var template = window.collection = new CollectionTemplate(container);

  //Now initialize it
  template.init();
});